/* BaseCommonUIMixin.js */

"use strict";
const _ = require("lodash");
const FormDialog = require("./app/customfeedback/formdialog/FormDialogComponent");

let mixin = (superKlass) =>
    class BaseCommonUIMixin extends superKlass {
        getCssClassFromContinuation(continuation) {
            return "jnib-engine-continuation-id-" + continuation.getId();
        }
        findComponentFromContinuation(continuation) {
            let component = null;
            let componentElem = document.querySelector(
                "." + this.getCssClassFromContinuation(continuation)
            );
            if (componentElem && componentElem.component) {
                component = componentElem.component;
            }
            return component;
        }
        findUserFeedbackComponentFromContinuation(continuation) {
            let userFeedback = null;
            let component = this.findComponentFromContinuation(continuation);

            if (_.has(component, "$steve.di")) {
                //reaching into the STEVE internals to make this work...
                let di = component.$teve.di;
                let registered = di.getRegistered("$teve.ui.userFeedback");
                userFeedback = registered.registeredObj;
            } else if (_.isFunction(component.getUserFeedback)) {
                userFeedback = component.getUserFeedback();
            }
            return userFeedback;
        }
        /**
         * Show Dialog Form (with OK and Cancel buttons) for the passed dialogInfo
         * object and return a Promise that resolves the data the user entered in the
         * formdialog if the "Ok" button is selected.  Otherwise return null to indicate a
         * cancel selection.
         */
        pmShowDialogForm(continuation, dialogInfo) {
            let userFeedback = this.findUserFeedbackComponentFromContinuation(continuation);
            if (userFeedback) {
                let formDialogCmpnt = new FormDialog({
                    title: dialogInfo.getTitle(),
                    message: dialogInfo.getMainTitle(),
                    confirmDetails: {
                        type: "text",
                        text: _.get(dialogInfo, "okText", "OK"),
                    },
                    rejectDetails: {
                        type: "text",
                        text: _.get(dialogInfo, "cancelText", "Cancel"),
                    },
                    formData: {
                        typeInformation: dialogInfo.jtype,
                        pristineValue: dialogInfo.getFormData(),
                    },
                });
                return userFeedback
                    .displayCustom(formDialogCmpnt, {})
                    .then((value) => {
                        return Promise.resolve(value);
                    })
                    .catch((/*e*/) => {
                        return Promise.resolve();
                    });
            } else {
                return Promise.resolve();
            }
        }
        /**
         * Show Error Message Dialog
         */
        pmShowErrorMsgDialog(continuation, msgObj) {
            let userFeedback = this.findUserFeedbackComponentFromContinuation(continuation);
            if (userFeedback) {
                return userFeedback
                    .displayError({
                        error: {
                            errorCode: "Error",
                            errorTitle: msgObj.title,
                            errorMsg: msgObj.message,
                        },
                        confirmDetails: {
                            type: "text",
                            text: _.get(msgObj, "okText", "OK"),
                        },
                    })
                    .then(() => {
                        return Promise.resolve();
                    })
                    .catch((/*e*/) => {
                        return Promise.resolve();
                    });
            } else {
                return Promise.resolve();
            }
        }

        /**
         * Show Warning Message Dialog
         */
        pmShowWarningMsgDialog(continuation, msgObj) {
            let userFeedback = this.findUserFeedbackComponentFromContinuation(continuation);
            if (userFeedback) {
                return userFeedback
                    .displayError({
                        error: {
                            errorCode: "Warrning",
                            errorTitle: msgObj.title,
                            errorMsg: msgObj.message,
                        },
                        confirmDetails: {
                            type: "text",
                            text: _.get(msgObj, "okText", "OK"),
                        },
                    })
                    .then(() => {
                        return Promise.resolve();
                    })
                    .catch((/*e*/) => {
                        return Promise.resolve();
                    });
            } else {
                return Promise.resolve();
            }
        }

        /**
         * Show Info Message Dialog
         */
        pmShowInfoMsgDialog(continuation, msgObj) {
            let userFeedback = this.findUserFeedbackComponentFromContinuation(continuation);
            if (userFeedback) {
                return userFeedback
                    .displayNotification(msgObj.message, {
                        title: msgObj.title,
                        confirmDetails: {
                            type: "text",
                            text: _.get(msgObj, "okText", "OK"),
                        },
                    })
                    .then(() => {
                        return Promise.resolve();
                    })
                    .catch((/*e*/) => {
                        return Promise.resolve();
                    });
            } else {
                return Promise.resolve();
            }
        }

        pmShowQuestionMsgDialog(continuation, msgObj) {
            let userFeedback = this.findUserFeedbackComponentFromContinuation(continuation);
            if (userFeedback) {
                return userFeedback
                    .displayConfirmation(msgObj.message, {
                        title: msgObj.title,
                        confirmDetails: {
                            type: "text",
                            text: _.get(msgObj, "okText", "Yes"),
                        },
                        rejectDetails: {
                            type: "text",
                            text: _.get(msgObj, "cancelText", "No"),
                        },
                    })
                    .then(() => {
                        return Promise.resolve(true);
                    })
                    .catch((e) => {
                        if (e.userRejected) {
                            return Promise.resolve(false);
                        } else {
                            return Promise.resolve();
                        }
                    });
            } else {
                return Promise.resolve();
            }
        }

        pmShowConfirmMsgDialog(continuation, msgObj) {
            let userFeedback = this.findUserFeedbackComponentFromContinuation(continuation);
            if (userFeedback) {
                return userFeedback
                    .displayConfirmation(msgObj.message, {
                        title: msgObj.title,
                        confirmDetails: {
                            type: "text",
                            text: _.get(msgObj, "okText", "OK"),
                        },
                        rejectDetails: {
                            type: "text",
                            text: _.get(msgObj, "cancelText", "Cancel"),
                        },
                    })
                    .then(() => {
                        return Promise.resolve(true);
                    })
                    .catch((e) => {
                        if (e.userRejected) {
                            return Promise.resolve(false);
                        } else {
                            return Promise.resolve();
                        }
                    });
            } else {
                return Promise.resolve();
            }
        }
    };
module.exports = mixin;
